import React, { useState } from "react";
import SectionHeading from "../components/shared/SectionHeading";
import Toppic from "../assets/becomePartner/topPic.png";
import img1 from "../assets/becomePartner/image1.png";
import img2 from "../assets/becomePartner/image2.png";
import img3 from "../assets/becomePartner/image3.png";
import img4 from "../assets/becomePartner/image4.png";
import img5 from "../assets/becomePartner/image5.png";
import img6 from "../assets/becomePartner/image6.png";
import galaxy from "../assets/becomePartner/galaxySvg.svg";
import UniversityPartners from "../components/home/UniversityPartner";
import img21 from "../assets/becomePartner/image21.png";
import img22 from "../assets/becomePartner/image22.png";
import img23 from "../assets/becomePartner/image23.png";
import img24 from "../assets/becomePartner/image24.png";
import img25 from "../assets/becomePartner/image25.png";
import img26 from "../assets/becomePartner/image26.png";
import FormImage from "../assets/becomePartner/formImage.png";

// import FormPopUp from "../components/common/PopUp";
// import DownloadPopUp from "../components/common/DownloadedPopUp";

const items = [
  {
    id: 1,
    img: img1,
    title: "Biggest Product Offerings: ",
    description:
      "Collaborate with India's Leading Universities on a single platform, among the diverse range of offerings.",
  },
  {
    index: 2,
    img: img2,
    title: "Flexibility:",
    description:
      "Enjoy the freedom to work from anywhere, anytime, accommodating your schedule and preferences.",
  },
  {
    index: 3,
    img: img3,
    title: "Recognition:",
    description:
      "Join us without any initial investment, enabling you to add product offerings at zero cost and cater to all customer needs effectively.",
  },
  {
    index: 4,
    img: img4,
    title: "Limitless Earning Potential:",
    description:
      "With the future of education shifting online, seize the opportunity to earn substantial incentives and commissions.",
  },
  {
    index: 5,
    img: img5,
    title: "24*6 Support:",
    description:
      "Benefit from innovative technology support and continuous assistance from Team CV, ensuring you're never alone on your journey.",
  },
  {
    index: 6,
    img: img6,
    title: "Recognition:",
    description:
      "Represent prestigious NAAC A, A+, and Grade 1 Universities, gaining recognition and credibility in the education industry.",
  },
];

const WhoItems = [
  {
    id: 1,
    img: img21,
    color: "#FDEBB7",
    title: "Tuition Centers",
  },
  {
    index: 2,
    img: img22,
    color: "#FEB7B4",
    title: "Tutorials",
  },
  {
    index: 3,
    img: img23,
    color: "#C3C3DC",
    title: "Degree colleges",
  },
  {
    index: 4,
    img: img24,
    color: "#BFB3A4",
    title: "After School Learning Centers",
  },
  {
    index: 5,
    img: img25,
    color: "#CAEAD1",
    title: "Other Educational Centers",
  },
  {
    index: 6,
    img: img26,
    color: "#E6E9ED",
    title: "Coaching Centers",
  },
];

const BecomePartner = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validationForm(formData);

    if (Object.keys(validationErrors).length === 0) {
      // Submit the form
      console.log("Form submitted successfully!", formData); //TODO: Remove me
    } else {
      setErrors(validationErrors);
      console.log("Form validation failed!"); //TODO: Remove me
    }
  };

  const validationForm = (data) => {
    const validationErrors = {};

    // Full Name validation
    if (!data.fullName.trim()) {
      validationErrors.fullName = "Name is required";
    }
    // City validation
    if (!data.city.trim()) {
      validationErrors.city = "City is required";
    }

    // Email validation
    if (!data.email.trim()) {
      validationErrors.email = "Email is required";
    } else if (!isValidEmail(data.email)) {
      validationErrors.email = "Invalid email format";
    }

    // Phone validation
    if (!data.phone.trim()) {
      validationErrors.phone = "Phone number is required";
    } else if (!isValidPhone(data.phone)) {
      validationErrors.phone = "Invalid phone number format";
    }

    return validationErrors;
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isValidPhone = (phone) => {
    return /^\d{10}$/.test(phone);
  };
  return (
    <div className="overflow-hidden max-w-[1380px] mx-auto ">
      <div className=" sm:w-11/12 md:w-4/5 lg:w-3/4 xl:w-[94%] mx-auto">
        {/* {head Section} */}
        <div className="flex flex-row items-center justify-between  py-12">
          <div className="flex-grow">
            <SectionHeading>
              <div className="text-left">
                <h2 className="text-secondary-color text-2xl lg:text-5xl inline-block">
                  Partner{" "}
                  <span className="text-primary-color text-2xl lg:text-5xl">
                    With
                  </span>
                </h2>
                <div className="text-primary-color text-2xl lg:text-5xl">
                  Mentorsity
                </div>
              </div>
            </SectionHeading>
            <div></div>
          </div>
          <div className="justify-self-end">
            <img
              src={Toppic}
              alt=""
              className="max-sm:w-[85%] max-sm:ml-auto "
            />
          </div>
        </div>
        {/* {Paragraph Section} */}
        <div className=" mt-4 relative">
          <div className="text-left mb-8 inset-0">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
              <span className="text-secondary-color "> Empowering </span>
              <span className="text-primary-color "> Channel Partners</span>
            </h2>
          </div>
          <p
            className="lg:text-3xl  lg:leading-10 text-justify  "
            style={{ wordSpacing: "4px" }}
          >
            We invite channel partners to empower them with access to a wide
            array of offerings in the burgeoning online education sector; all on
            a single platform. This comes with the flexibility of remote work,
            zero upfront investment, and unlimited earning potential. With 24*6
            support and opportunities to represent prestigious NAAC A, A+, and
            Grade 1 Universities, we aim to empower channel partners to thrive
            and succeed. Join us today and together, and let's unlock endless
            opportunities in the dynamic world of education.
            {/* <button className="secondary-lg-Btn">lorem ipsum</button> */}
          </p>
        </div>
        {/* {why Section} */}
        <div className=" mt-14 relative">
          <div className="">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
              <span className="text-primary-color ">Why </span>
              <span className=" text-secondary-color ">Partner with us?</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 mt-14 md:grid-cols-2 justify-items-center lg:grid-cols-3 gap-14 ">
            {items.map((item, index) => (
              <div
                key={index}
                className="p-3 bg-[#F3F5FE] pt-16 pb-12 relative flex flex-col justify-center text-center   shadow-md  rounded-md isolation-isolate"
              >
                <div className="absolute  drop-shadow-none border-none bg-white h-24 w-24 transform -translate-x-1/2 rounded-full  left-[50%] inset-0 -top-12">
                  <img
                    src={item.img}
                    alt="  "
                    className=" mx-auto transform translate-y-1/4 h-16 w-16"
                  />
                </div>
                <h2 className="mb-4 text-2xl font-semibold"> {item.title}</h2>
                <p className="font-semibold text-justify px-4 text-lg ">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        {/* {offering and who can be Section} */}
        <div className="mt-14 relative ">
          <div className="  ">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
              <span className="text-primary-color ">Our </span>
              <span className=" text-secondary-color ">Offerings</span>
            </h2>
            <p
              className="lg:text-3xl lg:leading-10 text-left mt-6 lg:w-2/3 w-3/4"
              style={{ wordSpacing: "4px" }}
            >
              Enable educators to explore boundless earning potential with the
              flexibility of remote work, while fostering an environment to
              learn and grow together.
            </p>
          </div>
          <div className="mt-14  ">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
              <span className="text-primary-color ">Who can be our </span>
              <span className=" text-secondary-color ">partners</span>
            </h2>
            <div className="grid grid-cols-1 mt-16  md:grid-cols-2 justify-items-center lg:grid-cols-3 gap-14 ">
              {WhoItems.map((item, index) => (
                <div
                  key={index}
                  className="p-3  pt-16   pb-12 relative flex flex-col justify-center text-center  w-full  shadow-lg rounded-md isolation-isolate"
                >
                  <div
                    className="absolute  drop-shadow-none border-none bg-white h-24 w-24 transform -translate-x-1/2 rounded-full  left-[50%] inset-0 -top-10"
                    style={{ backgroundColor: `${item.color}` }}
                  >
                    <img
                      src={item.img}
                      alt="  "
                      className=" mx-auto transform translate-y-1/4 h-16 w-16"
                    />
                  </div>
                  <h2 className="mb-4 text-2xl font-semibold  translate-y-2/3">
                    {" "}
                    {item.title}
                  </h2>
                </div>
              ))}
            </div>
          </div>

          <img
            src={galaxy}
            alt=""
            className="h-screen absolute  top-0 right-0 w-full transform translate-x-1/2 -translate-y-24  hidden lg:block z-20"
          />
        </div>
        {/* {partnering companies and university partners Section} */}
        <div className="mt-14 relative">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
              <span className="text-primary-color ">Partnering </span>
              <span className="text-secondary-color ">Companies</span>
            </h2>
          </div>
        </div>
        <div className="mt-14 relative">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
              <span className="text-secondary-color ">University </span>
              <span className="text-primary-color ">Partners</span>
            </h2>
            <UniversityPartners />
          </div>
        </div>
        {/* {form section} */}
        <div className="mt-14 max-sm:pb-8 relative">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium	 text-left">
            <span className="text-primary-color">Become</span>{" "}
            <span className="text-secondary-color"> our partner today! </span>
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 w-full lg:justify-between justify-center  content-center align-middle items-center ">
            <div className="w-full lg:self-start mt-8   lg:order-1 order-2">
              <form
                onSubmit={handleSubmit}
                className="flex gap-2 lg:w-[94%] flex-col"
              >
                <div className="">
                  <label htmlFor="fullName" className="text-2xl ">
                    Name
                  </label>
                  <div className="mt-2">
                    <input
                      id="fullName"
                      type="text"
                      name="fullName"
                      className="border-2 border-primary-color p-3 rounded-md w-full"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Enter your name"
                    />
                    {errors.fullName && (
                      <p className="text-red-600">{errors.fullName}</p>
                    )}
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="text-2xl">
                    Email ID
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="border-2 border-primary-color p-3 rounded-md w-full"
                      placeholder="Enter your email address"
                    />
                    {errors.email && (
                      <p className="text-red-600">{errors.email}</p>
                    )}
                  </div>
                </div>

                <div>
                  <label htmlFor="phone" className="text-2xl">
                    Phone Number
                  </label>
                  <div className="mt-2">
                    <input
                      id="phone"
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="border-2 border-primary-color p-3 rounded-md w-full"
                      placeholder="Enter your phone number"
                    />
                    {errors.phone && (
                      <p className="text-red-600">{errors.phone}</p>
                    )}
                  </div>
                </div>

                <div>
                  <label htmlFor="City" className="text-2xl">
                    City
                  </label>

                  <div className="mt-2">
                    <input
                      id="city"
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="border-2 border-primary-color p-3 rounded-md w-full"
                      placeholder="Enter your city"
                    />
                    {errors.city && (
                      <p className="text-red-600">{errors.city}</p>
                    )}
                  </div>
                </div>
                <div className="flex lg:mt-4 items-center justify-center">
                  <button
                    className="bg-primary-color hover:bg-[white] hover:text-primary-color border-2 border-primary-color text-white font-normal py-3 px-3 rounded-lg w-full text-xl "
                    type="submit"
                  >
                    Request a call back
                  </button>
                </div>
              </form>
            </div>
            <div className=" lg:order-2  order-1">
              <img src={FormImage} alt="" className="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomePartner;
